import { createFileRoute } from '@tanstack/react-router'
import { FleetAnalysis } from 'pages/fleetAnalysis/FleetAnalysis'
import { z } from 'zod'

export const Route = createFileRoute('/fleet-analysis/$siteID')({
  component: FleetAnalysis,
  validateSearch: z.object({
    dataType: z.string().optional(),
  }),
  staticData: {
    layout: {
      enableScrolling: true,
    },
  },
})
